<template>
  <div class="mt-12">

    <div class="mb-6">
      <vs-input
        v-validate="'required'"
        data-vv-validate-on="blur"
        name="orgId"
        icon-no-border
        icon="icon icon-globe"
        icon-pack="feather"
        label-placeholder="รหัสองค์กร"
        v-model="org_id"
        class="w-full"
        @keydown="onKeydown($event)"/>
      <span class="text-danger text-sm" v-show="errors.has('orgId')">กรุณากรอกรหัสองค์กร</span>
    </div>

    <div class="mb-6">
      <vs-input
        v-validate="'required'"
        data-vv-validate-on="blur"
        name="username"
        icon-no-border
        icon="icon icon-user"
        icon-pack="feather"
        label-placeholder="ชื่อผู้ใช้งาน"
        v-model="username"
        class="w-full"
        @keydown="onKeydown($event)"/>
      <span class="text-danger text-sm" v-show="errors.has('username')">กรุณากรอกชื่อผู้ใช้งาน</span>
    </div>

    <div class="mb-6">
      <vs-input
        data-vv-validate-on="blur"
        v-validate="'required'"
        type="password"
        name="password"
        icon-no-border
        icon="icon icon-lock"
        icon-pack="feather"
        label-placeholder="รหัสผ่าน"
        v-model="password"
        class="w-full mt-6"
        @keydown="onKeydown($event)"/>
      <span class="text-danger text-sm" v-show="errors.has('password')">กรุณากรอกรหัสผ่าน</span>
    </div>

<!--    <div class="flex flex-wrap justify-between my-5">-->
<!--        <vs-checkbox v-model="checkbox_remember_me" class="mb-3">จดจำฉัน</vs-checkbox>-->
<!--        <router-link to="/pages/forgot-password">ลืมรหัสผ่าน?</router-link>-->
<!--    </div>-->
    <div class="flex flex-wrap justify-between mb-3">
      <vs-button :disabled="!validateForm" @click="loginJWT" >เข้าสู่ระบบ</vs-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      org_id: '',
      checkbox_remember_me: false
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.username != '' && this.password != '' && this.org_id != '';
    },
  },
  methods: {
    onKeydown(e){
      if(e.keyCode == 13 || e.which == 13) { //Enter keycode
        this.loginJWT()
      }
    },
    loginJWT() {
      this.$vs.loading()
      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        user: {
          username: this.username,
          password: this.password,
          org_id: this.org_id
        }
      }
      this.$store.dispatch('loginSession', payload).then(() => {
        this.$vs.loading.close()
      }).catch(error => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'ผิดพลาด',
          text: error.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      });
    }
  }
}
</script>

